module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet2-24b1981eed3dd4007de4d670a5a03c1d.svg";